export const REFUND_SCOPE = {
    ALL_PAYMENTS: 'all_payments',
    SELECT_PAYMENT: 'select_payment',
}

export const REFUND_TYPE = {
    TOTAL: 0,
    PERCENTAGE_OR_VALUE: 1,
    ITEM_VALUE: 2,
}

export const PAYMENT_STATUS_PARTIALLY_PAID = 1

export const STEP = {
    SCOPE: 1,
    DETAILS: 2,
}

export const STEPS = [
    { id: STEP.SCOPE, label: 'Refund scope' },
    { id: STEP.DETAILS, label: 'Refund details' },
]

// Sub-views inside the scope step: the two scope cards, or the payment picker list.
export const SCOPE_SUBSTEP = {
    CARDS: 'cards',
    PAYMENTS: 'payments',
}

export const paymentMethodLabel = (payment) => {
    if (!payment) return ''
    const allocations = payment.allocations || []
    if (allocations.length === 0) return payment.paymentTypeDescription || ''
    if (allocations.length === 1) return allocations[0].paymentTypeDescription || ''
    return 'Multiple'
}

export const paymentItemsLabel = (payment, reservation) => {
    if (!payment || !reservation) return ''
    const genderPrices = reservation.bookingGenderPrices || []
    const components = reservation.bookingComponents || []
    const parts = [];

    ;(payment.tickets || []).forEach((ticket) => {
        const match = genderPrices.find(genderPrice => genderPrice.id === ticket.itemId)
        if (match) parts.push(`${match.audienceTypeDescription} x${ticket.quantity}`)
    })
    ;(payment.components || []).forEach((component) => {
        const match = components.find(bookingComponent => bookingComponent.id === component.itemId)
        if (match) parts.push(`${match.component.name} x${component.quantity}`)
    })

    return parts.join(', ')
}

export const paymentSubLabel = (payment, reservation) => {
    return [paymentMethodLabel(payment), paymentItemsLabel(payment, reservation)]
        .filter(Boolean)
        .join(' • ')
}



// WEBPACK FOOTER //
// ./src/utils/refundHelpers.js